import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import classNames from './List.css'
import { fetchPlaylists } from '../redux/playlists'
import { fetchAlbums } from '../redux/albums'
import { unshareAlbum } from '../redux/share'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import Icon from '../components/Icon'
import { createImageGetter } from '../utils/images'

const LIST_NAMES = {
  all: 'All Albums',
  favourites: 'Favourite Albums',
  shared: 'Shared With Me',
  recent: 'Recent'
}

class List extends Component {
  state = {
    sortBy: 'name',
    sortDesc: false
  }
  componentDidMount () {
    const { shouldFetchLists, fetchPlaylists, shouldFetchAlbums, fetchAlbums } = this.props
    if (shouldFetchLists) fetchPlaylists()
    if (shouldFetchAlbums) fetchAlbums()
  }
  sortAlbums = (a, b) => {
    const { sortBy, sortDesc } = this.state
    if (sortDesc) {
      return a[sortBy] > b[sortBy] ? -1 : 1
    }
    return a[sortBy] > b[sortBy] ? 1 : -1
  }
  renderAlbum = album => {
    const { params, getImageSource, getAlbumInfo, unshareAlbum, me } = this.props
    const info = getAlbumInfo(album)
    return (
      <li key={album.id} className={classNames.album}>
        <div
          className={classNames.thumb}
          style={{ backgroundImage: `url(${getImageSource(album.cover)})` }}
        />
        <Link to={`/album/${album.id}`} className={classNames.name}>
          {album.name}
          {info &&
            <div className={classNames.info}>
              {info}
            </div>
          }
        </Link>
        {params.id === 'shared' && album.user_id !== me.id &&
          <button onClick={() => unshareAlbum(album.id, me.id)} className={classNames.button}>
            <Icon icon='close' />
          </button>
        }
      </li>
    )
  }
  render () {
    const { list, name, listAlbums, error, fetchPlaylists, fetchAlbums } = this.props
    if (error.lists) {
      return <ErrorMessage message='List could not be loaded' onRetry={fetchPlaylists} />
    }
    if (error.albums) {
      return <ErrorMessage message='Albums could not be loaded' onRetry={fetchAlbums} />
    }
    if (!listAlbums) {
      return <LoadingSpinner />
    }
    const setSort = value => () => this.setState({
      sortBy: value,
      sortDesc: this.state.sortBy === value && !this.state.sortDesc
    })
    const sortStyle = value => this.state.sortBy === value ? { textDecoration: 'underline' } : null
    return (
      <div className={classNames.page}>
        {list &&
          <Link to={`/groups/${list.id}`} className={classNames.editButton}>
            Edit group
          </Link>
        }
        <h2>{name}</h2>
        <div style={{ fontSize: '12px', margin: '5px 0' }}>
          Sort by:
          {' '}
          <button style={sortStyle('name')} onClick={setSort('name')}>Name</button>
          {' · '}
          <button style={sortStyle('created_at')} onClick={setSort('created_at')}>Creation Date</button>
        </div>
        <ul>
          {listAlbums.sort(this.sortAlbums).map(this.renderAlbum)}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = ({ entities, albums, auth, playlists }, { params }) => {
  const list = entities.playlists[params.id]
  let name
  let listAlbums
  if (list) {
    name = list.name
    listAlbums = JSON.parse(list.json_data).albums.map(i => entities.albums[i.album]).filter(a => a)
  } else if (albums.all.data && albums.favourites.data) {
    name = LIST_NAMES[params.id]
    listAlbums = filterAlbums(params.id, albums, entities, auth)
  }
  return {
    list,
    name,
    listAlbums,
    shouldFetchLists: /^\d+$/.test(params.id) && !list,
    shouldFetchAlbums: !albums.all.data,
    error: {
      lists: playlists.error,
      albums: albums.all.error
    },
    getImageSource: createImageGetter(auth),
    getAlbumInfo: album => {
      if (album.user_id === auth.user.id || !entities.users[album.user_id]) {
        return null
      }
      const user = entities.users[album.user_id]
      return `Shared by ${user.name}`
    },
    me: auth.user
  }
}

export function filterAlbums (id, albums, entities, auth) {
  if (!albums.all.data || !albums.favourites.data) {
    return []
  }
  const denormalize = id => entities.albums[id]
  const all = albums.all.data.map(denormalize)
  const mine = all.filter(a => a.user_id === auth.user.id)
  if (id === 'favourites') {
    return [
      ...mine.filter(a => a.favourite),
      ...albums.favourites.data.map(denormalize)
    ]
  }
  if (id === 'all') {
    return mine
  }
  if (id === 'shared') {
    return [
      ...mine.filter(a => a.image_share),
      ...all.filter(a => a.user_id !== auth.user.id)
    ]
  }
  if (id === 'recent') {
    return all.filter(filterRecent).sort(sortRecent)
  }
}

function filterRecent (album) {
  const date = new Date()
  date.setDate(date.getDate() - 7)
  return new Date(album.created_at) > date || new Date(album.updated_at) > date
}

function sortRecent (a, b) {
  a = a.updated_at || a.created_at
  b = b.updated_at || b.created_at
  return new Date(b) - new Date(a)
}

const mapDispatchToProps = {
  fetchAlbums,
  fetchPlaylists,
  unshareAlbum
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/pages/List.js